import axios from "axios"
import {
    INTERMEDIARIES_ENDPOINT,
    SEARCH_INTERMEDIARIES_ENDPOINT,
    UPDATE_INTERMEDIARIES_ENDPOINT
} from "../../../../../../../utility/SourceAPI"

/**
 * Única capa que habla con el backend de intermediarios.
 * Devuelve siempre `response.data`, nunca el envoltorio de axios, y deja que el
 * error suba tal cual: quien decide qué hacer con él es el thunk (rejectWithValue).
 */

export const fetchIntermediaries = async () => {
    const response = await axios.get(INTERMEDIARIES_ENDPOINT)
    return response.data
}

//Agregados por intermediario (saldos, créditos, comisiones): más caro que la lista
export const fetchIntermediariesResume = async () => {
    const response = await axios.get(INTERMEDIARIES_ENDPOINT.concat('resume/'))
    return response.data
}

//El endpoint de búsqueda ya termina en `?intermediary_id=`, por eso el id se concatena
//en vez de ir en `params`; se codifica para que no rompa la query si deja de ser numérico
export const fetchIntermediary = async (id) => {
    const response = await axios.get(SEARCH_INTERMEDIARIES_ENDPOINT.concat(encodeURIComponent(id)))
    return response.data
}

export const createIntermediary = async (intermediary) => {
    const response = await axios.post(INTERMEDIARIES_ENDPOINT, intermediary)
    return response.data
}

export const updateIntermediary = async (intermediary) => {
    const response = await axios.put(UPDATE_INTERMEDIARIES_ENDPOINT.concat(encodeURIComponent(intermediary.id)), intermediary)
    return response.data
}

//Baja lógica: el backend no espera cuerpo
export const deactivateIntermediary = async (id) => {
    const response = await axios.put(INTERMEDIARIES_ENDPOINT.concat(`deactivate/${encodeURIComponent(id)}`))
    return response.data
}
